export default "__VITE_ASSET__Dpb6g_zq__"